import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { formaterPrix } from '../formats.js';
export function BoutonAchat({ ctx, oeuvre, }) {
    if (!oeuvre.achat)
        return null;
    const lien = oeuvre.achat.lien.replace(/&lang=(fr|en)$/, `&lang=${ctx.langue}`);
    return (_jsx("p", { className: "achat", children: _jsxs("a", { className: "bouton-achat", href: lien, rel: "nofollow", children: [ctx.l.acheterEnLigne, " \u2014 ", formaterPrix(oeuvre.achat, ctx.langue), " ", ctx.l.prixTtc] }) }));
}
//# sourceMappingURL=achat.js.map